import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Grid, Icon } from 'semantic-ui-react';

const getStyles = height =>
  height ? { maxHeight: `${height}vh`, minHeight: `${height}vh` } : {};

const ScrollContainer = props => {
  const {
    scrollRef,
    onScrollUp,
    onScrollDown,
    enableScrollButtons,
    children,
    height,
    disabledUp,
    disabledDown,
    className,
  } = props;

  const style = getStyles(height);

  return (
    <Grid className={classNames('pos-scroll-grid flex-no-wrap', className)}>
      <div
        className={classNames(
          'scrollable',
          enableScrollButtons ? 'fifteen wide' : 'sixteen wide',
          'column'
        )}
        style={style}
        ref={scrollRef}
      >
        {children}
      </div>
      {enableScrollButtons && (
        <Grid.Column width={1} className="tab-menu">
          <Grid padded="vertically" className="scroll-buttons-container">
            <Icon
              disabled={disabledUp}
              className="scroll-buttons primary-color"
              name="chevron up"
              size="large"
              onClick={onScrollUp}
            />
            <Icon
              disabled={disabledDown}
              className="scroll-buttons primary-color"
              name="chevron down"
              size="large"
              onClick={onScrollDown}
            />
          </Grid>
        </Grid.Column>
      )}
    </Grid>
  );
};
ScrollContainer.propTypes = {
  scrollRef: PropTypes.object,
  height: PropTypes.string,
  clickHandler: PropTypes.func,
  onScrollUp: PropTypes.func,
  onScrollDown: PropTypes.func,
  enableScrollButtons: PropTypes.bool,
  disabledUp: PropTypes.bool,
  disabledDown: PropTypes.bool,
};

ScrollContainer.defaultProps = {
  height: null,
  disabledUp: false,
  disabledDown: false,
};

export default ScrollContainer;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/ScrollContainer.js